import { Injectable } from '@angular/core';

import { ApiService, LogService, AppContext } from './../shared';
import { Route, Port } from './../shared/models';

@Injectable()
export class SaveRouteService {
  show: boolean = false;
  origins = Array<{ count: number, selected: boolean, port: Port }>();
  destinations = Array<{ count: number, selected: boolean, port: Port }>();
  routes = Array<any>();
  message: string = '';

  apiService: any = null;
  appContext: any = null;

  routesList: Array<any> = new Array<any>();

  constructor(private api: ApiService, private logger: LogService, private app: AppContext) {
    this.apiService = api;
    this.appContext = app;
    this.routesList = app.routes;
  }

  save(route: any) {
    this.message = ''; // clear previous message
    if (!route.selected) {
      this.message = 'saving';
      this.saveRoute(route);
    } else {
      this.message = 'deleting';
      this.deleteRoute(route);
    }
  }

  checkIfLoggedIn() {
    if (!this.app.isLoggedIn && this.show) {
      this.app.showMessage('Sign in Required', 'You must sign in to use this feature');
      return;
    }
  }

  updateRoutes() {
    this.routes = [];
    if (this.origins.length === 0 || this.destinations.length === 0) {
      return;
    }
    for (let currentOrigin = 0; currentOrigin < this.origins.length; currentOrigin++) {
      for (let currentDestination = 0; currentDestination < this.destinations.length; currentDestination++) {
        let formatted = {
          origin: this.origins[currentOrigin],
          destination: this.destinations[currentDestination]
        };

        this.formatRoute(formatted);
        this.routes.push(formatted);
      }
    }
    this.logger.log('save-route.service', 'updateRoutes', this.routes);
  }

  formatRoute(route: any) {
    route.selected = false;
    if (this.app.routes === null || this.app.routes === undefined) {
      return;
    }
    for (let current = 0; current < this.app.routes.length; current++) {
      if (this.app.routes[current].originId === route.origin.port.id && this.app.routes[current].destinationId === route.destination.port.id) {
        this.logger.log('save-route.service', 'formatRoute', route);
        route.selected = true;
      }
    }
  }

  saveRoute(route: any) {
    let formatted = {
      origin_id: route.origin.port.id,
      origin_name: route.origin.port.title,
      destination_id: route.destination.port.id,
      destination_name: route.destination.port.title
    };

    let alreadySaved = false;
    for (let current = 0; current < this.app.routes.length; current ++) {
      if (this.app.routes[current].originId == route.origin.port.id && this.app.routes[current].destinationId == route.destination.port.id) {
        alreadySaved = true;
        break;
      }
    }

    if (!alreadySaved) {
      this.api.getApiClient().then(client => this.callSave(client, route, formatted));
    }
  }

  deleteRoute(route: any) {
    var cognitoIdentityId = this.apiService.getCognitoId();
    let formatted = {
      cognitoId: cognitoIdentityId,
      originId: route.origin.port.id,
      destinationId: route.destination.port.id
    };
 
    this.api.getApiClient().then(client => this.callDelete(client, route, formatted));
  }

  callSave(apigClient: any, route, formatted) {
    this.logger.log('save-route.service', 'callSave', formatted);
    let params = {
    };
    let body = formatted;
    let additionalParams = {
      headers: { 'Content-Type': 'application/json' },
      queryParams: {}
    };
    try {
      apigClient.routesFavoritePost(params, body, additionalParams)
        .then((result) => {
          this.logger.log('save-route.service', 'resolve', result);
          route.selected = true;
          this.message = 'Route Saved';
          if (this.app.routes === null || this.app.routes === undefined) {
            this.app.routes = new Array<any>();
          }
          // ****
          let newFavoriteRoute = {
            originId: route.origin.port.id,
            originName: route.origin.port.title,
            destinationId: route.destination.port.id,
            destinationName: route.destination.port.title
          };
      
          let favoriteRoutes = this.app.routes;
          favoriteRoutes.push(newFavoriteRoute);
          this.app.routes = favoriteRoutes;
      
          localStorage.setItem('favoriteRoutes', JSON.stringify(favoriteRoutes));
          // ****
          // this.app.routes.push({
          //   originId: formatted.origin_id,
          //   originName: formatted.origin_name,
          //   destinationId: formatted.destination_id,
          //   destinationName: formatted.destination_name
          // });
        }).catch((err) => {
          this.message = 'an error occurred';
          this.api.handleError(err);
        });
    } catch (ex) {
      this.message = 'an error occurred';
      this.logger.log('save-route.service', 'catch', ex);
    }
  }

  callDelete(apigClient: any, route, formatted) {
    this.logger.log('save-route.service', 'callDelete', route);

    let params = {
      originId: formatted.originId,
      destinationId: formatted.destinationId
    };

    let body = formatted;
    let additionalParams = {
      headers: { 'Content-Type': 'application/json' },
      queryParams: {}
    };
    try {
      apigClient.v2RoutesFavoriteDelete(params, body, additionalParams)
        .then((result) => {
          this.logger.log('save-route.service', 'resolve', result);
          // ****
          let resultRouteList = this.app.routes;
          for (let current = 0; current < this.routes.length; current ++) {
            if (resultRouteList[current].originId == route.origin.port.id && resultRouteList[current].destinationId == route.destination.port.id) {
              resultRouteList.splice(current, 1);
              break;
            }
          }
          this.app.routes = resultRouteList;
          localStorage.setItem('favoriteRoutes', JSON.stringify(this.routesList));
          if (result.data.body != undefined) {
            try {
              let resultRoutes = JSON.parse(result.data.body);
              if (Array.isArray(resultRoutes)) {
                localStorage.setItem('favoriteRoutes', JSON.stringify(resultRoutes));
              }
            } catch (ex) {
              console.log(ex);
            }
          }
          this.app.routes = JSON.parse(localStorage.getItem('favoriteRoutes'));
          // ****
          route.selected = false;
          this.message = 'Route Deleted';
        }).catch((err) => {
          this.message = 'an error occurred';
          this.api.handleError(err);
        });
    } catch (ex) {
      this.message = 'an error occurred';
      this.logger.log('save-route.service', 'catch', ex);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/save-route/save-route.service.ts